module.exports = __webpack_public_path__ + "img/021-sock.8596fc2b.svg";